<script setup lang="ts">
  const { t } = useI18n();

  usePageHead({
    pageName: t('SERVICE_CALCULATOR_PAGE.TITLE'),
    description: t('SERVICE_CALCULATOR_PAGE.DESCRIPTION'),
    isMainNavPage: true,
  });
</script>

<template>
  <Calculator mode="service" />
</template>
